import { RequestError } from '../Component/Error/SmartError'

export function parseError(err: any): RequestError {
    return {
        error: err.response?.status || err?.status,
        message: err.message || `${err.response?.statusText || err?.statusText }`,
        detail: `${err.response?.data?.detail || err.response?.data || err.data }`,
    }
}